import { Check, CircleAlert } from 'lucide-react';
import { Badge } from '@/components/reui/badge';
import { cn } from '@/lib/utils';
import { VARIANT_CLASS, etiquetaEstadoRdt, varianteEstadoRdt } from '@/components/rdt/estado-chip-variantes';

interface Props {
  estado: string;
  /** RdtEstadoDerivado.esperandoPoliza — pisa la etiqueta/color de `estado`
   *  con el matiz "A la espera de póliza" cuando está en true. */
  esperandoPoliza?: boolean;
  className?: string;
}

// Chip compacto reusado en la card de RDT, el header de la ficha y la
// leyenda — Badge radius="full" (plan_migracion_reui.md, R3-C, DP-R3-a:
// c-badge-22 https://reui.io/preview/base/components/c-badge-22?ref=mcp)
// con los colores de Paleta B por className (VARIANT_CLASS, sin variante
// estándar de reui/badge que los exprese) — icono/dot según la variante
// (dashed+alerta para "A chequear", tilde para "Facturado", punto lleno
// para el resto, tal como el ejemplo). El mapa tipado vive en
// estado-chip-variantes.ts (archivo sin JSX, regla §1.15 de fast refresh).
// La API de este componente no cambia (la usa el Avivador).
export function EstadoChip({ estado, esperandoPoliza, className }: Props) {
  const estadoMostrado = etiquetaEstadoRdt(estado, esperandoPoliza);
  const variante = varianteEstadoRdt(estado, esperandoPoliza);
  return (
    <Badge radius="full" className={cn('h-auto', VARIANT_CLASS[variante], className)}>
      {variante === 'facturado' ? (
        <Check className="size-2.5" strokeWidth={3} aria-hidden="true" />
      ) : variante === 'chequear' ? (
        <CircleAlert className="size-2.5" strokeWidth={2.4} aria-hidden="true" />
      ) : (
        <span aria-hidden="true" className="ms-0.25 size-1.25 rounded-full! bg-[currentColor]" />
      )}
      {estadoMostrado}
    </Badge>
  );
}
